import React from 'react';

const Spinner = (props) => (
  <div>
    <div className={` dimScreen ${props.status}`}></div>
    <div className={`lds-facebook ${props.status}`}><div></div><div></div><div></div></div>
  </div>
)

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/Common/Spinner.js